import React, { Component } from 'react';
import { connect } from 'react-redux';
import { setSearchTerm, clearSearchTerm } from '../../redux/actions/result.action';
import { push } from 'connected-react-router';
import './ResultAnswer.scss';

//icon
import speakerIcon from '../../assets/speaker.svg';
import { setTextToSpeak } from '../../redux/actions/text.action';
import Text2Voice from '../Text2Voice/Text2Voice';

class ResultAnswer extends Component<{ input: string, search: any, speak: any }, { currIndex: number, message: string, playing: boolean }> {
  private speech: any;

  constructor(props: any) {
    super(props);
    this.state = {
      currIndex: -1,
      message: '',
      playing: false
    }
  }

  speak() {
    this.setState({ currIndex: 0 })
  }

  /**
   * Main render method
   */
  render() {
    return (
      <div className="resultanswer">
        <div className="text" onClick={() => {
          this.props.search(this.props.input);
        }}> {this.props.input}</div>
        <img src={speakerIcon} className="voice-img" alt="speaker" onClick={() => {
          this.setState({ message: this.props.input, playing: true })
        }} />
        {this.state.message != '' && <Text2Voice textArray={[this.state.message]} playing={this.state.playing} callback={()=>{
            this.setState({message: '', playing: false})
        }}/>}
      </div>
    );
  }
}

const mapStateToProps = (state: any) => {
  return {

  };
};

const mapDispatchToProps = (dispatch: any) => {
  return {
    search(term: string) {
      dispatch(clearSearchTerm());
      dispatch(setSearchTerm(term));
      dispatch(push('/result'))
    },
    speak(text: string) {
      dispatch(setTextToSpeak(text));
    }
  }
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ResultAnswer);